import React, {createContext, ReactNode, useContext} from 'react';
import useSiteContent, {SiteContentState} from "../hooks/useSiteContent";

// The homepage content document feeds two unrelated components (the hero and the
// announcement bar). Mounted once at the layout level they share a single
// GET /site-content instead of racing two of them and painting two revisions.
const SiteContentContext = createContext<SiteContentState | null>(null);

export const SiteContentProvider = ({children}: { children: ReactNode }) => {
    const state = useSiteContent();

    return (
        <SiteContentContext.Provider value={state}>
            {children}
        </SiteContentContext.Provider>
    );
};

// Consumers work with or without the provider: outside it (tests, any future
// standalone mount) the component loads the document itself, exactly as before.
export const useSiteContentValue = (): SiteContentState => {
    const provided = useContext(SiteContentContext);
    // Always called - hook order may not depend on the provider being there.
    const own = useSiteContent({enabled: provided === null});

    return provided ?? own;
};

export default SiteContentContext;
